export const DownloadTestIdFactory = {
    getUnreliableDownloadModalTestId: () => 'unreliable-download-modal',
    getUnreliableDownloadModalDontShowAgainTestId: () => [
        DownloadTestIdFactory.getUnreliableDownloadModalTestId(),
        'dont-show-again',
    ].join('-'),
    getUnreliableDownloadModalIconTestId: () => [DownloadTestIdFactory.getUnreliableDownloadModalTestId(), 'icon'].join('-'),
    getUnreliableDownloadModalProceedTestId: () => [
        DownloadTestIdFactory.getUnreliableDownloadModalTestId(),
        'proceed',
    ].join('-'),
};
